import React from 'react'
import PropTypes from 'prop-types'
import { Text, Icon, Button, Divider, ScrollSpy } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import SectionPanel from '../../components/sectionPanel'
import hasSimilarProperties from '../../utils/hasSimilarProperties'
import { buildBreadCrumbs } from '../breadcrumbs'
import { VIEW_SIMILAR_PROPERTIES } from '../../statics'
import cls from './index.scss'

const cx = classnames.bind(cls)

const bulletPoints = [
  {
    iconName: 'handshake',
    title: 'Mutual Agreement',
    description:
      'When a homeowner and lender reach an agreement so the homeowner can keep the property.',
  },
  {
    iconName: 'landmark',
    title: 'Bankruptcy',
    description:
      'When a homeowner files for bankruptcy protection, this results in an automatic stay being placed on the property. The bankruptcy doesn’t stop the foreclosure, but delays it until the homeowner resolves the debt or the lender gets approval from the bankruptcy court to proceed with the sale.',
  },
  {
    iconName: 'hands-holding-dollar',
    title: 'Beneficiary (Lender) Request',
    description:
      'The beneficiary (lender) can decide to cancel the sale for any reason. The lender may not be ready to sell the property; may sell it elsewhere or may get paid off by the homeowner.',
  },

  {
    iconName: 'arrow-right-arrow-left',
    title: 'Property No Longer Marketed on Auction.com',
    description:
      'In some cases, the property will no longer be marketed by Auction.com but there is the potential that the property will go to sale.',
  },
]
export const CancelledPropertyDescription = ({ listing }) => {
  const selectedCounty = buildBreadCrumbs(listing, true)[2]
  const similarProperties = listing.recommended_listings || []

  return (
    <SectionPanel>
      <div
        className={cx('cancelled-property-description')}
        data-elm-id='cancelled_property_actions'
      >
        <div style={{ marginBottom: 40 }}>
          <Text weight='normal' size='big' as='p' color='gray'>
            The property you were looking for has been removed at this time.
          </Text>
        </div>
        <Text weight='normal' size='big' as='p' color='gray'>
          Still looking for a property?
        </Text>
        <div className={cx('cancelled-property-cta')}>
          <h1>
            <Button
              role='primary'
              link={selectedCounty.url}
              elmId='cancelled_search_county_properties'
            >
              Search {selectedCounty.label} Properties
            </Button>
          </h1>
          {hasSimilarProperties(similarProperties) && (
            <>
              <Text weight='normal' size='big' as='span' color='gray'>
                Or
              </Text>

              <ScrollSpy selector='#similar_properties'>
                {({ scrollTo }) => (
                  <Button
                    role='secondary'
                    onClick={scrollTo}
                    elmId='cancelled_view_similar_properties_button'
                  >
                    {VIEW_SIMILAR_PROPERTIES}
                  </Button>
                )}
              </ScrollSpy>
            </>
          )}
        </div>
      </div>
      <div data-elm-id='cancelled_property_explanation'>
        <Text weight='medium' size='huge' as='p'>
          Why are properties removed?
        </Text>
        <Text weight='normal' size='big' as='p' color='gray'>
          Properties may be removed for several reasons. Some of the more common
          ones include:
        </Text>
        <Divider clearing />
        {bulletPoints.map((bulletPoint, index) => (
          <React.Fragment key={index}>
            <div className={cx('bullet-point')}>
              <div className={cx('icon-container')}>
                <Icon
                  name={bulletPoint.iconName}
                  iconStyle='light'
                  size='huge'
                  color='gray'
                />
              </div>
              <div style={{ width: '100%' }}>
                <Text weight='normal' size='big' as='p' color='gray'>
                  {`${index + 1}. ${bulletPoint.title}`}
                </Text>
                <Text weight='normal' size='small' as='p' color='gray'>
                  {bulletPoint.description}
                </Text>
              </div>
            </div>
            <Divider />
          </React.Fragment>
        ))}
      </div>
    </SectionPanel>
  )
}

CancelledPropertyDescription.propTypes = {
  listing: PropTypes.object,
}
